import { useEffect, useState, ReactNode } from 'react';
import { createPortal } from 'react-dom';

interface PortalProps {
  children: ReactNode;
  targetId?: string;
}

/**
 * Portal component - renders children outside the React hierarchy
 * into a DOM node (default: document.body or #overlay-root if it exists)
 */
export const Portal = ({ children, targetId = 'overlay-root' }: PortalProps) => {
  const [mounted, setMounted] = useState(false);
  const [container, setContainer] = useState<HTMLElement | null>(null);

  useEffect(() => {
    // Find or create the overlay container
    let element = document.getElementById(targetId);

    if (!element) {
      // Fallback: use body if overlay-root doesn't exist
      element = document.body;
    }

    setContainer(element);
    setMounted(true);

    return () => setMounted(false);
  }, [targetId]);

  if (!mounted || !container) {
    return null;
  }

  return createPortal(children, container);
};

export default Portal;
